// extracted by mini-css-extract-plugin
export default {"link":"BaseLink_link__ytUhd","button":"BaseLink_button__d-EmO","s":"BaseLink_s__gif5l","m":"BaseLink_m__MS4T7","headerBtn":"BaseLink_headerBtn__+gdsN"};